import { IApiCallStatus } from './../common/apis/csosApi';
import { IRequestsApiCallStatus, IRequestsState } from '.';
import { compose as lcompose, find as lfind, eq as leq } from 'lodash/fp';
import { pathOr, prop } from 'rambda';

export const getRequestsCallStatus: (state: IRequestsState) => IApiCallStatus =
  lcompose(
    prop('apiCallStatus'),
    lfind<IRequestsApiCallStatus>({ type: 'GetRequests' }),
    pathOr<IRequestsApiCallStatus[]>([], 'apiCallStatus')
  );

export const reloadRequests: (state: IRequestsState) => boolean = lcompose(
  leq(null),
  getRequestsCallStatus
);
